import { Outlet, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";

import { listenForPageHide, recordVisit } from "@/api/activity";
import { UpdateRequired } from "@/app/AppVersion";
import { useSession } from "@/app/session";
import { SeoHead } from "@/site/SeoHead";

/** Signed-in page visits for Admin → Activity log (api/activity.ts). */
function useVisitTracker() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { status, user } = useSession();
  const userId = user?.id;
  useEffect(() => {
    listenForPageHide();
  }, []);
  useEffect(() => {
    if (status === "signed-in") recordVisit(pathname);
  }, [pathname, status, userId]);
}

/** Every route: the page, then the public pages' head tags (after the page's own). */
export function RootLayout() {
  useVisitTracker();
  return (
    <>
      <Outlet />
      <UpdateRequired />
      <SeoHead />
    </>
  );
}
